import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const FuelHistoryDashboard = lazyLoader(
  () => import("Containers/FuelHistory/FuelHistoryList/FuelHistoryDashboard")
);

export const FuelHistoryList = () => {
  return (
    <Layout>
      <FuelHistoryDashboard />
    </Layout>
  );
};
